import React from 'react'
import { motion } from 'framer-motion'

type Props = {
  text: string
}

const AnimatedText = ({ text }: Props) => {
  const words = text.split(' ')

  const container = {
    hidden: { opacity: 0 },
    visible: () => ({
      opacity: 1
    })
  }

  return (
    <motion.div
      style={{ display: 'flex' }}
      variants={container}
      initial="hidden"
      animate="visible"
    >
      {words.map((word, index) => (
        <motion.span
          animate={{ opacity: 1, x: 0 }}
          initial={{ opacity: 0, x: 20 }}
          transition={{
            type: 'spring',
            damping: 12,
            stiffness: 100,
            repeat: Infinity,
            repeatType: 'reverse',
            repeatDelay: 1,
            duration: 0.5
          }}
          style={{ marginRight: '5px', fontSize: '16px' }}
          key={index}
        >
          {word}
        </motion.span>
      ))}
    </motion.div>
  )
}

export default AnimatedText
